export default __webpack_public_path__ + "cb5278e00c6900b1482560498791ae3a.png";